/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Layout, Button, Row, Menu } from "antd";
import "antd/dist/antd.css";
import "./styles.scss";
import SideBarOpen from "../../components/Navbar";
import AppFooter from "../../components/AppFooter";
import Notification from "../Notification";
import appLogo from "../../assests/images/smcsLogo.svg";

import logoSidebar from "../../assests/images/logo-sidebar.png";
import SideBarClosed from "../../components/SideMenu/SideMenuItems";
import { globalPath } from "../../config/globalPaths";
import { menuItems } from "../../config/sideMenuList";
import SideMenu from "./SideMenu";
import urls from "../../api/urls";

const { Header, Footer, Content, Sider } = Layout;

const MainLayout = ({ component }) => {
  const [menuSideBarVisible, setMenuSideBarVisible] = useState(false);
  const [newCollapse, setNewCollapse] = useState(true);
  const [activeSideTab, setActiveSideTab] = useState(menuItems[0]);
  const [newNotification, setNewNotification] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [showNotificationBell, setShowNotificationBell] = useState(false);
  const { NOTIFICATION_SERVICE } = urls;
  useEffect(() => {
    const storedUser = sessionStorage.getItem("userinfo");
    const userId = JSON.parse(storedUser)?.userId;

    if (userId) {
      const eventSource = new EventSource(
        NOTIFICATION_SERVICE + "sse/subscribe/" + userId
      );

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          setNewNotification({ ...data, newNotification: true });
          setShowNotificationBell(true);
        } catch (error) {
          console.error("Error parsing SSE data:", error);
        }
      };

      eventSource.onerror = (error) => {
        console.error("SSE Connection Error:", error);
        eventSource.close();
      };

      return () => {
        eventSource.close();
      };
    }
  }, []);
  const unauthorizedUser = window.location.pathname;

  const handleDrawerClose = () => {
    setMenuSideBarVisible(!menuSideBarVisible);
  };

  const handleOpenDrawer = () => {
    setMenuSideBarVisible(!menuSideBarVisible);
  };
  const closeDrawer = () => {
    setMenuSideBarVisible(false);
    setNewCollapse(!newCollapse);
  };

  const Menu = <SideBarClosed />;
  return (
    <div className="App">
      {!globalPath.includes(unauthorizedUser) &&
      localStorage.getItem("loggedOutTime") ? (
        <Layout>
          <Sider
            width={70}
            style={{ minHeight: "100vh", color: "white" }}
            collapsible
            collapsed={false}
            trigger={null}
          >
            <div className="sidemenu-container">
              {/* <Button onClick={handleMenuSideBar} className="hamburger">
                {menuSideBarVisible ? (
                  <img src={hamIcon} />
                ) : (
                  <Row>
                    <div>
                      <img src={hamIcon} />
                    </div>
                  </Row>
                )}
              </Button> */}

              <Row
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  width: 70,
                  marginTop: 20,
                }}
              >
                <div>
                  <img src={logoSidebar} className="logo-sidebar" />
                </div>
              </Row>

              <SideBarClosed
                visibleDrawer={menuSideBarVisible}
                setActiveSideTab={setActiveSideTab}
                setMenuSideBarVisible={setMenuSideBarVisible}
              />
            </div>
          </Sider>

          <div
            className={`side-menu-dropdown-box ${
              menuSideBarVisible ? "open" : ""
            }`}
          >
            {/* {menuSideBarVisible && ( */}
            <div
              style={{
                background: "#ebf1fa",
                width: "100%",
                height: "100%",
                boxShadow: "inset -4px 2px 4px rgb(99 126 165 / 10%)",
                justifyContent: "center",
                padding: "10px",
              }}
            >
              <div>
                <img src={appLogo} className="web-logo" />
              </div>
              <SideMenu
                activeSideTab={activeSideTab}
                menuSideBarVisible={menuSideBarVisible}
                setMenuSideBarVisible={setMenuSideBarVisible}
              />
            </div>
            {/* )} */}
          </div>

          <Layout>
            <Header>
              <SideBarOpen
                menu={Menu}
                showLogo={!menuSideBarVisible}
                visibleDrawer={menuSideBarVisible}
                handleDrawerClose={handleDrawerClose}
                handleOpenDrawer={handleOpenDrawer}
                onClose={closeDrawer}
                showNotification={showNotification}
                setShowNotification={setShowNotification}
                showNotificationBell={showNotificationBell}
                setShowNotificationBell={setShowNotificationBell}
              />
            </Header>
            <Content>
              <div
                className="dashboard-layout-content"
                onClick={() => {
                  setMenuSideBarVisible(false);
                }}
              >
                {component}

                <Notification
                  showNotification={showNotification}
                  newNotification={newNotification}
                  setShowNotification={setShowNotification}
                />
              </div>
            </Content>
            <Footer>
              <AppFooter />
            </Footer>
          </Layout>
        </Layout>
      ) : (
        <Content>{component}</Content>
      )}
    </div>
  );
};

MainLayout.propTypes = {
  component: PropTypes.node,
  userAuthorized: PropTypes.bool,
  userRole: PropTypes.string,
  handleUserRole: PropTypes.func,
};

MainLayout.defaultProps = {
  userAuthorized: false,
};

export default React.memo(MainLayout);
